import React, { useEffect, useState } from 'react';
import ArrowRightIcon from '@material-ui/icons/ArrowRight';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import { Box, Tooltip, Typography, Accordion } from '@material-ui/core';

import { colors } from 'theme/color-palette';
import previewElementStyle from './PeviewElements.style';
import { StyledAccordionSummary } from '../timeframe/TimeFrame.style';
import { PINNED_DATA, PIN_MAX_LIMIT, PIN_MAX_LIMIT_TOOLTIP } from 'constants/constant';

const PinnedDataFolder = (props) => {
	const classes = previewElementStyle();
	const [isPinnedDataOpen, setIsPinnedDataOpen] = useState(false);

	if (props.pinnedAttributesCount === 0) {
		return null;
	}

	useEffect(() => {
		if (props.searchQuery) {
			const attributeNamesString =
				props.pinnedAttribute?.metrics?.join('')?.toLowerCase() +
				props.pinnedAttribute?.dimensions?.join('')?.toLowerCase();
			if (attributeNamesString.includes(props.searchQuery?.toLowerCase())) {
				setIsPinnedDataOpen(true);
			}
		}
	}, [props.searchQuery]);

	return (
		<Accordion
			square={true}
			elevation={0}
			key={'pinned-data'}
			expanded={isPinnedDataOpen}
			id={`accordian-pinned-data`}
			className={classes.pinnedFolderAccordion}
			onChange={() => setIsPinnedDataOpen(!isPinnedDataOpen)}>
			<StyledAccordionSummary aria-controls="panel1a-content" id="panel1a-header">
				{isPinnedDataOpen ? <ArrowDropDownIcon /> : <ArrowRightIcon />}
				<Box className={classes.pinnedDataHeader}>
					<Typography className={classes.subHeaderText}>{PINNED_DATA}</Typography>
					<Box className={classes.pinnedDataCount}>
						<Typography className={classes.attributesCount}>
							{props.pinnedAttributesCount}
						</Typography>
						{props.pinnedAttributesCount >= PIN_MAX_LIMIT && (
							<Tooltip
								title={<Box className={classes.pinAttributeTooltip}>{PIN_MAX_LIMIT_TOOLTIP}</Box>}
								placement="bottom"
								arrow>
								<InfoOutlinedIcon fontSize="small" style={{ color: colors.GREY }} />
							</Tooltip>
						)}
					</Box>
				</Box>
			</StyledAccordionSummary>
			{props.children}
		</Accordion>
	);
};

export default PinnedDataFolder;
